import {Injectable} from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import {Observable, of, throwError} from 'rxjs';
import {AppService} from 'src/app/core/services/app.service';
import {catchError} from 'rxjs/operators';
import {HttpError} from 'src/app/core/models/http-error.model';
import {PageContent} from 'src/app/core/models/page-content.model';

@Injectable({
  providedIn: 'root'
})
export class ContentResolver implements Resolve<{ title: string, text: string }> {
  constructor(private appService: AppService, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PageContent> {
    return this.appService.getPageContent(route.paramMap.get('id')).pipe(
      catchError((response: HttpError, ob) => {
        if (response.status === 422) {
          this.router.navigateByUrl('/404');
        }
        return throwError(response);
      })
    );

  }
}
